"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var ChevronLeftIcon = function ChevronLeftIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    width: "12",
    height: "22",
    viewBox: "0 0 12 22"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.87308 21.1736L0.661426 11.8161C0.44044 11.5864 0.3125 11.3083 0.3125 11.006C0.3125 10.7366 0.406496 10.4761 0.572516 10.2853L9.87308 0.826425C10.0708 0.620898 10.3267 0.5 10.6291 0.5C11.2339 0.5 11.6875 0.983592 11.6875 1.61226C11.6875 1.90242 11.5712 2.19257 11.3851 2.3981L2.91782 11.006L11.3851 19.614C11.5712 19.8195 11.6875 20.0976 11.6875 20.3998C11.6875 21.0285 11.2339 21.5 10.6291 21.5C10.3267 21.5 10.0708 21.3791 9.87308 21.1736Z"
  }));
};
var _default = ChevronLeftIcon;
exports.default = _default;